<template>
  <div v-if="payload" :class="{ link_entity_with_alert_button: show_alert_button, 'is-justify-content-center': centerComponent }">
    <router-link :to="{ name: simplifiedData.route_name, query: simplifiedData.query }"
                 :class="{ un_clickable: simplifiedData.route_name == undefined }" class="blue_text link-entity">
      <u @click="clickedText" @mouseover="onMouseOver" @mouseleave="onMouseLeave">{{simplifiedData.display_text}}</u>
      <span class="has-text-danger">{{ simplifiedData.priority_warning }}</span>
      <span class="is-size-7"> {{ simplifiedData.active_at }}</span>
      <p v-if="payload.last_login" class="last_login">LL: {{ time_helper.makeTimeReadable(payload.last_login) }}</p>
      <p v-if="payload.tags" class="tags">{{ payload.tags }}</p>
    </router-link>
    <div class="horizontal_space"></div>
    <div>
      <div v-if="show_alert_button">
        <alert-button :payload="payload" :additional_data="{ resource_type: mergedData.resource_type }"></alert-button>
      </div>
      <div v-if="simplifiedData.additional_components" >
        <div v-for="additional_component in simplifiedData.additional_components" :key="additional_component" >
          <div class="vertical_space"></div>
          <component :is="additional_component" :payload="mergedData"></component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import AlertButton from '@/components/AlertButton'
import PriorityVetting from '@/components/PriorityVetting'
import CompanySuitcase from '@/components/CompanySuitcase'
import TopFirmBadge from '@/components/entities/company/TopFirmBadge'
import ButtonEvaluate from '@/components/ButtonEvaluate'
import IsHot from '@/components/IsHot'
import IsFreeze from '@/components/IsFreeze'
import IsWatch from '@/components/IsWatch'

export default {
  name: 'link_entity',
  props: ['payload', 'additional_data'],
  data () {
    return {
      time_helper: new TimeHelper(),
      is_fixed: false,
      show_alert_button: false
    }
  },
  computed: {
    isRebase () {
      return this.$settings.get({ path: 'operation_name' }) == 'Rebase'
    },
    centerComponent () {
      return this.additional_data ? this.additional_data.center : false
    },
    mergedData () {
      return { ...this.payload, ...this.additional_data }
    },
    simplifiedData: function () {
      if (this.mergedData.resource_type == 'Applicant') {
        return {
          route_name: 'admin-applicants',
          query: { show_id: this.payload.resource_id },
          display_text: this.payload.first_name + ' ' + this.payload.last_name + this.$utils.getVetted(this.payload),
          is_clickable: true,
          title: `${this.payload.full_name} | ${this.payload.phone_number} | ${this.payload.resource_id} | ${this.$moment(this.payload.updated_at).format('DD/MM/YYYY')}`,
          modal_width_on_click: 1500,
          modal_name: this.isRebase ? 'ModalApplicant' : 'ModalApplicant',
          additional_components: ['CompanySuitcase', 'IsFreeze']
        }
      }
      if (this.mergedData.resource_type == 'Admin') {
        return {
          route_name: 'admin-list',
          query: { show_id: this.payload.id },
          display_text: this.payload.full_name,
          is_clickable: true,
          modal_name: 'AdminListInfo'
        }
      }
      if (this.mergedData.resource_type == 'Position') {
        return {
          route_name: 'company-positions',
          query: {
            company_id: this.payload.company ? this.payload.company.resource_id : null,
            show_id: this.payload.id
          },
          display_text: this.payload.title + (this.payload.is_discrete ? ' (DISCRETE)' : ''),
          priority_warning: (this.payload.priority_warning ? ` (${this.payload.priority_warning})` : ''),
          active_at: this.mergedData.active_at ? this.$moment(this.mergedData.active_at).format('DD/MM/YYYY') : '',
          modal_width: 1500,
          modal_name: 'ModalPosition',
          additional_components: ['IsHot', 'CompanySuitcase', 'IsWatch']
        }
      }
      if (this.mergedData.resource_type == 'Company') {
        return {
          route_name: 'admin-companies',
          query: { show_id: this.payload.user_id || this.payload.resource_id },
          display_text: this.payload.name,
          modal_name: 'CompanyInfo',
          additional_components: ['CompanySuitcase', 'TopFirmBadge']
        }
      }
      if (this.mergedData.resource_type == 'CompanyEmployee') {
        return {
          route_name: 'admin-company-employees',
          query: { show_id: this.payload.id },
          display_text: this.payload.name,
          modal_name: 'CompanyEmployeeInfo'
        }
      }
      if (this.mergedData.resource_type == 'Offer') {
        return {
          route_name: 'admin-offers',
          query: { show_id: this.payload.id },
          display_text: `Offer #${this.payload.id}`,
          disable_modal: true,
          additional_components: ['CompanySuitcase', 'ButtonEvaluate']
        }
      }
      if (this.mergedData.resource_type == 'Text') {
        return {
          display_text: this.payload.designator,
          resource_type: this.payload.resource_type,
          modal_name: 'TextsForm'
        }
      }
      return {}
    },
    ...mapGetters('modals', ['isModalOpen', 'findModal'])
  },
  mounted () {
    this.show_alert_button = ['Applicant', 'Position', 'Company', 'Offer'].includes(this.mergedData.resource_type)
  },
  methods: {
    onMouseOver () {
      this.is_fixed = false
      this.openModal({ modal_open_action: 'hover' })
    },
    openModal (params) {
      if (this.simplifiedData.disable_modal) {
        return
      }
      this.create({
        designator: 'link-entity-resource-modal',
        resource_type: this.mergedData.resource_type,
        resource_id: this.mergedData.resource_id,
        component_name: this.simplifiedData.modal_name,
        data: this.mergedData,
        modal_title: this.simplifiedData.title || this.simplifiedData.display_text,
        modal_width: this.simplifiedData.modal_width,
        ...params
      })
    },
    getModal () {
      return this.findModal({ type: 'designator', value: 'link-entity-resource-modal' })
    },
    removeModal () {
      if (!this.isModalOpen({ type: 'designator', value: 'link-entity-resource-modal' })) {
        return
      }
      this.remove(this.getModal())
    },
    onMouseLeave () {
      if (this.is_fixed) {
        return
      }
      this.removeModal()
    },
    clickedText (event) {
      if (!this.simplifiedData.is_clickable) {
        return
      }
      this.is_fixed = true
      event.preventDefault()
      this.openModal({ modal_width: this.simplifiedData.modal_width_on_click, is_center_modal: true, modal_open_action: 'click' })
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    AlertButton,
    PriorityVetting,
    CompanySuitcase,
    TopFirmBadge,
    ButtonEvaluate,
    IsHot,
    IsFreeze,
    IsWatch
  }
}
</script>
<style scoped>
  .last_login{
    font-size: 10px;
    color: var(--color-text);
    margin: 0;
    padding: 0;
  }
  .tags {
    font-size: 10px;
    color: var(--color-text);
    margin: 0;
    padding: 0;
  }
  .link_entity_with_alert_button{
    display: flex;
    align-items: center;
  }
  .un_clickable{
    pointer-events: none;
  }
  .link-entity{
    color: #3273dc !important;
  }
</style>
